import { generateUserSig } from '../service/api'; // 小程序构建npm引入
import { mapState } from 'vuex';
import store from '../store/index';
import common from '../service/common';

export default {
    data() {
        return {
            signInfo: null,
        };
    },
    watch: {
        signInfo: {
            handler(newV, oldV) {
                return { ...newV };
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        ...mapState(['isImSign']),
    },
    methods: {
        //登陆im
        imLogin(cb) {
            let that = this;
            new Promise((resolve, reject) => {
                generateUserSig({ sdkAppId: '1400802351' }).then(res => {
                    if (res.code === '0') {
                        common.mdTrack('', '获取用户签名', "{'签名':" + res.data + '}');
                        // console.log(
                        //     res,
                        //     'xiesi用户签名----',
                        //     process.env.VUE_APP_USERID +
                        //     uni.getStorageSync('wxUserInfoSync').id
                        // );
                        // console.log(
                        //     '!!!开始登录TIM----',
                        //     uni.getStorageSync('wxUserInfoSync')
                        // );
                        //登录TIM
                        uni.$TUIKit
                            .login({
                                userID: process.env.VUE_APP_USERID +
                                    uni.getStorageSync('wxUserInfoSync').id,
                                userSig: res.data,
                            })
                            .then(imResponse => {
                                if (imResponse.code === 0) {
                                //   console.log(
                                //     '全局--TIM登录成功====',
                                //     imResponse,
                                //     this.$checkLoginReadyCallback
                                //   );
                                  common.mdTrack('', 'TIM登录成功-imResponse');
                                  this.signInfo = imResponse.data;
                                  
                                  cb && cb();
                                  //app.js的onLaunch执行完之后再执行Page的onLoad
                                  uni.$checkLogin = true;
                                  if (uni.$checkLoginReadyCallback) {
                                    // console.warn(
                                    //   'app.js的onLaunch执行完--!!##'
                                    // );
                                    uni.$checkLoginReadyCallback(res);
                                  }
                                  resolve(imResponse);
                                  //im登陆成功
                                  //   uni.$TUIKit.on (uni.$TIM.EVENT.SDK_READY, that.onSdkReady);
                                  //   //im推送的单聊、群聊、群提示、群系统通知的新消息
                                  //   uni.$TUIKit.on (
                                  //     uni.$TIM.EVENT.MESSAGE_RECEIVED,
                                  //     that.onMessageReceived
                                  //   );
                                }
                            })
                            .catch(function(imError) {
                                console.warn('im-login-error:', imError); // 登录失败的相关信息
                            });
                    } else {
                        console.warn('获取用户签名失败', res);
                        resolve('err');
                    }
                });
            });
        },
        onSdkReady() {
            // console.log('im登陆成功----login.js');
        },
        onMessageReceived(event) {
            // console.log('===im推送的单聊、群聊、群提示、群系统通知的新消息');
        },
    },
};